/**
 * Popup de newsletter/promo (sections/pop-up.liquid).
 * Estende <modal-element> — ganha open/close + eventos modal:open/modal:close.
 *
 * Atributos:
 *   data-mode  → "live" (respeita dismissal) | "development" (delay fixo 2s)
 *   data-delay → segundos antes de auto-abrir (live)
 *
 * Em design_mode (editor), não auto-abre.
 *
 * Depende de base.js (ModalElement, EssenceBaseComponent, theme.storageKeys).
 */
(function () {
  "use strict";

  if (customElements.get("popup-element")) return;
  if (!window.ModalElement) return;

  class PopupElement extends window.ModalElement {
    init() {
      super.init();
      if (window.Shopify && window.Shopify.designMode) return;

      this.mode = this.dataset.mode;

      if (this.mode === "live") {
        var dismissed = window.localStorage.getItem(theme.storageKeys.popupDismissedKey) === "true";
        if (dismissed) return;

        this.addEventListener("modal:close", this.recordDismiss.bind(this), {
          signal: this.__tdController.signal,
          once: true,
        });
      }

      var delay = this.mode === "development"
        ? 2000
        : (parseInt(this.dataset.delay, 10) || 0) * 1000;

      this.openTimer = window.setTimeout(this.open.bind(this), delay);
    }

    recordDismiss() {
      window.localStorage.setItem(theme.storageKeys.popupDismissedKey, "true");
    }

    destroy() {
      if (this.openTimer) {
        window.clearTimeout(this.openTimer);
        this.openTimer = null;
      }
    }
  }

  customElements.define("popup-element", PopupElement);
})();
